/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-call */
import request from '@hb/sharp-request';
import { UserVo } from '@/vo/user';
import { Toast } from '@hb/coffee';
import { newGatewayUrl } from '@/constant';
import requestDefault from '@/shared/utils/request';
import { SceneTypeEnum, SupplySceneEnum } from '@/enums/scene-type';
import { MaritalStatusCheckContact, MaritalStatusEnum, UserAdditionalInfoType } from './types';

// 嘉卡贷填信息
export const update = (userInfo: UserVo.BasicInfo): Promise<number> => request.postGate('f.user.base.update', userInfo, { baseURL: newGatewayUrl });

// 中原补充用户资料
export const addUserInfo = (
  userInfo: Partial<UserVo.BasicInfo>,
): Promise<boolean> => requestDefault.postGate('f.userInfo.personalInfo.add', userInfo);

// 嘉卡贷获取信息；以及中原获取用户信息
export const get = (): Promise<unknown> => request.postGate<UserVo.BasicInfo>('f.user.userPersonalInfo.get', {}, { baseURL: newGatewayUrl });


const transformSceneType = (scene: SceneTypeEnum) => (scene === SceneTypeEnum.PREAPPLY
  ? SupplySceneEnum.PRE_APPLY : SupplySceneEnum.LOAN_APPLY);

// 区分场景补充字段（新）
export const supplyNeedConfig = (commodityIds: string[], scene: SceneTypeEnum):
Promise<string[]> => requestDefault.postGate<string[]>(
  'f.userInfo.personalInfo.supplyNeedConfig',
  {
    scene: transformSceneType(scene),
    commodityIds,
  },
);

// 授信阶段 提交补充资料
export const supplySave = (userInfo: Partial<UserVo.BasicInfo>, sceneEnum: SceneTypeEnum):
Promise<boolean> => requestDefault.postGate<boolean>(
  'f.userInfo.personalInfo.supplySave',
  {
    ...userInfo,
    sceneEnum: transformSceneType(sceneEnum),
    /** 新老版本代码区分 */
    updateVersion: '1.1',
  },
);

export const updateZYQ = (userInfo: UserVo.PersonalInfo & {updateSource:number, updateScene:number})
: Promise<{ userBaseId: string }> => request
  .postGate<{ userBaseId: string }>('f.user.userInfo.update', userInfo, {
    baseURL: newGatewayUrl,
    loadingMessage: '提交中',
  })
  .then((data) => {
    Toast.success('提交成功');

    return data;
  });

// 更新用户额外的补充资料
export const updateUserAdditionalInfo = (userInfo: UserAdditionalInfoType)
: Promise<number> => requestDefault
  .postGate<number>('f.user.base.supplement', userInfo);

export const getPersonalAdditionalInfo = <T>(): Promise<T> => request.postGate<T>('f.user.userPersonalInfo.get', {}, { baseURL: newGatewayUrl });


/** 获取个人基本信息 */
export const getPersonalInfo = (): Promise<UserVo.BasicInfo> => request.postGate<UserVo.BasicInfo>('f.user.userPersonalInfo.get', {}, { baseURL: newGatewayUrl });

// 极融
export const addUserInfoJR = (
  userInfo: Partial<UserVo.BasicInfo>,
): Promise<number> => request.postGate('f.user.base.update', userInfo, { baseURL: newGatewayUrl });

// 臻有钱用户个人信息接口
export const getZYQ = (): Promise<UserVo.PersonalInfo> => request.postGate<UserVo.PersonalInfo>('f.user.personal.info', {}, { baseURL: newGatewayUrl });


/**
 * 校验用户和紧急联系人
 * https://yapi.hellobike.cn/project/3415/interface/api/256045
*/
export const checkUserContact = (params:{
  contactPhone?: string,
  contactName?: string,
  ocrName?: string,
  commodityId?: string,
}): Promise<UserVo.ContactCheckResult> => requestDefault.postGate('f.user.contact.check', { ...params });


/**
 * 用户补充资料必填项校验, 用户已婚，补充紧急联系人资料
 * https://yapi.hellobike.cn/project/3415/interface/api/278673
*/
export const personalInfoCheck = (commodityId: string, maritalStatus: MaritalStatusEnum):
Promise<MaritalStatusCheckContact> => requestDefault.postGate(
  'f.userInfo.personalInfo.check',
  {
    commodityId,
    maritalStatus,
  },
);

const UserPersonalInfoApi = {
  update,
  addUserInfo,
  get,
  updateZYQ,
  getPersonalInfo,
  addUserInfoJR,
  getZYQ,
  checkUserContact,
  supplySave,
  supplyNeedConfig,
  personalInfoCheck,
  updateUserAdditionalInfo,
};

export default UserPersonalInfoApi;
